import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import Cookies from "js-cookie";
import { TfiAnnouncement } from "react-icons/tfi";
import moment from "moment";

import { getAllAnnouncementsForEmployeeQueryOptions } from "@/config/queries/emp-query-options";
import { Skeleton } from "@/components/ui/skeleton/skeleton";
import { Button } from "@/components/ui/button/button";
import { Link } from "react-router-dom";

export const HomeAnnouncementCard = () => {
  const key = Cookies.get("key") as string;

  const startdate = useMemo(() => {
    const start = new Date();

    start.setUTCHours(0, 0, 0, 0);

    return start;
  }, []);

  const enddate = useMemo(() => {
    const end = new Date();

    end.setUTCHours(0, 0, 0, 0);
    end.setUTCDate(end.getUTCDate() + 1);

    return end;
  }, []);

  const { data, isPending, isFetching } = useQuery(
    getAllAnnouncementsForEmployeeQueryOptions(key, startdate, enddate)
  );

  const announcementData = useMemo(() => {
    if (isPending) {
      return 0;
    }

    if (data === undefined || data?.announcements === undefined) {
      return 0;
    }

    let count = 0;

    const result = data?.announcements;
    const today = moment();

    for (const ann of result) {
      const d = moment(ann?.createdAt);
      const isToday = today.isSame(d, "day");

      if (isToday) {
        count++;
      }
    }

    return count;
  }, [data, isPending, isFetching]);

  return (
    <>
      {isPending ? (
        <Skeleton className="w-60 h-20"></Skeleton>
      ) : (
        <div className="w-60 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border p-4">
          <div className="flex flex-row items-center pb-2 justify-between">
            <h2 className="text-sm font-medium">Today's Announcements</h2>

            <TfiAnnouncement className="w-4 h-4" />
          </div>
          <div className="pt-0 flex items-center justify-between">
            <div className="text-2xl font-bold">{announcementData || 0}</div>

            <div className="">
              <Button variant="default" asChild size="sm" className="">
                <Link to="/employee/announcements">All Announcements</Link>
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
